import React, { useState } from 'react';
import axios from 'axios';
import Box from '@mui/material/Box';
import requests from '../../utils/stls/Request';
import GenericTemplate from '../../templates/GenericTemplate';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import { green } from '@mui/material/colors';
import MUIDataTable from "mui-datatables";
import FromTextFieldKojoCd from '../../components/TextField/TextFieldKojoCd';
import FromTextFieldKataban from '../../components/TextField/TextFieldKataban';
import FromTextFieldColor from '../../components/TextField/TextFieldColor';
import FromTextFieldTeisyaku from '../../components/TextField/TextFieldTeisyaku';
import { chkHalfWidth, chkNumber, chkEmpty } from '../../common/chkTextValue';
import {Auth} from 'aws-amplify';
import moment from 'moment';

const P01Prg002Kata001: React.FC = () => {
  //変数定義
  const [post, setPosts] = useState([])
  //工場コード
  const [kojoCd, setKojoCd] = useState('');
  const [kojoCdError, setKojoCdError] = useState('');
  //形番
  const [kataban, setKataban] = useState('');
  const [katabanError, setKatabanError] = useState('');
  //色コード
  const [color, setColor] = useState('');
  const [colorError, setColorError] = useState('');
  //定尺
  const [teisyaku, setTeisyaku] = useState('');
  const [teisyakuError, setTeisyakuError] = useState('');

  const [loading, setLoading] = React.useState(false);
  const [success, setSuccess] = React.useState(false);

  const buttonSx = {
    ...(success && {
      bgcolor: green[500],
      '&:hover': {
        bgcolor: green[700],
      },
    }),
  };

  //requests.p01Mst001KataStockにリクエストする関数。
  const fetchRequest = async() => {
    setPosts([])

    //requestを投げるURL作成
    const URL = process.env.REACT_APP_APIURL_STLS + requests.p01Mst001KataStock + '/' + kojoCd
    const AuthToken = (await Auth.currentSession()).getIdToken().getJwtToken()
    axios.get(URL,
      {
        headers: {
          "X-API-KEY": process.env.REACT_APP_APIKEY_STLS || "",
          "Authorization": AuthToken || "",
        },
        params: {
          kataban:  kataban,  //形番
          color:    color,    //色コード
          teisyaku: teisyaku, //定尺
        },
        }).then((res) => {
        //成功したら Posts に result を格納。
        setPosts(res.data.result)
         if (res.data.result.length === 0) {
          alert('データはありません')
        }
        console.debug(res.data.result)
      }).catch(error => {
        console.log(error);
        alert('検索に失敗しました')
      }).finally(() => {
        setLoading(false);
      });
  };

  //検索・ボタン押下時の処理 
  const handleClick = (() => {
    let errMsg1 = ""
    let errMsg2 = ""
    let errMsg3 = ""
    let errMsg4 = ""
    //未入力チェック
    errMsg1 = chkEmpty(kojoCd)
    errMsg2 = chkEmpty(kataban)
    errMsg3 = chkEmpty(color)
    errMsg4 = chkEmpty(teisyaku)
    if (errMsg1.length > 0 && errMsg2.length > 0 && errMsg3.length > 0 && errMsg4.length > 0) {
      setKojoCdError(errMsg1)
      setKatabanError(errMsg2)
      setColorError(errMsg3)
      setTeisyakuError(errMsg4)
      alert('検索条件をどれか入力してください');
      return;
    }
    //半角文字チェック：工場コード 
    errMsg1 = chkHalfWidth(kojoCd)
    if (errMsg1.length > 0) {
      setKojoCdError(errMsg1)
      alert(errMsg1);
      return;
    }
    //半角文字チェック：形番 
    errMsg1 = chkHalfWidth(kataban)
    if (errMsg1.length > 0) {
      setKatabanError(errMsg1)
      alert(errMsg1);
      return;
    }
    //半角文字チェック：色コード
    errMsg1 = chkHalfWidth(color)
    if (errMsg1.length > 0) {
      setColorError(errMsg1)
      alert(errMsg1);
      return;
    }
    //数値チェック：定尺
    errMsg1 = chkNumber(teisyaku)
    if (errMsg1.length > 0) {
      setTeisyakuError(errMsg1)
      alert(errMsg1);
      return;
    }

    if (!loading) {
      setSuccess(false);
      setLoading(true);
      //apiコールする関数を呼び出す
      fetchRequest()
      setSuccess(true);
    }
  })

  //入力値チェック処理：工場コード
  const chkKojoCd = (event: any) => {
    let val = event.target.value
    setKojoCdError(chkHalfWidth(val))
    setKojoCd(val)
  }
  //入力値チェック処理：形番
  const chkKataban = (event: any) => {
    let val = event.target.value
    setKatabanError(chkHalfWidth(val))
    setKataban(val)
  }
  //入力値チェック処理：色コード
  const chkColor = (event: any) => {
    let val = event.target.value
    setColorError(chkHalfWidth(val))
    setColor(val)
  }
  //入力値チェック処理：定尺
  const chkTeisyaku = (event: any) => {
    let val = event.target.value
    setTeisyakuError(chkNumber(val))
    setTeisyaku(val)
  }

  //数値を右寄せマイナス値を赤文字表示
  function columnStyleRightRed(val: any) {
    return val < 0 ? {style:{textAlign:"right", color: "red" }} 
                   : {style:{textAlign:"right"}};
  }
   //日付をスラッシュ編集
   function dateEditDisplay(val: string) {
    return val.length === 8 ? moment(val).format("YYYY/MM/DD") : val;
  }
  //数値をカンマ編集
  function commaEditDisplay(val: any) {
    return Number(val).toLocaleString(undefined, { maximumFractionDigits: 3 });
  }  

  const column = [
    { name: "loc", label: "保管場所",
      options: {
        setCellProps: () => ({ style: { position: "sticky", left: 0, width: 80, background: "white", zIndex: 100 } }),
        setCellHeaderProps: () => ({ style: { position: "sticky", left: 0, width: 80, background: "white", zIndex: 101 } })
      }
    },
    { name: "mold_material", label: "形番　　", 
      options: {
        setCellProps: () => ({ style: { position: "sticky", left: 90, background: "white", zIndex: 102 } }),
        setCellHeaderProps: () => ({ style: { position: "sticky", left: 90, background: "white", zIndex: 103 } })
      }
    },
    { name: "color", label: "色コード　", 
      options: {
        setCellProps: () => ({ style: { position: "sticky", left: 180, background: "white", zIndex: 104 } }),
        setCellHeaderProps: () => ({ style: { position: "sticky", left: 180, background: "white", zIndex: 105 } })
      }
    },
    { name: "fixed_dimensions", label: "定尺", 
      options: {
        setCellProps: () => ({ style: { position: "sticky", left: 280, background: "white", zIndex: 106, 
                                        textAlign:"right"} }),
        setCellHeaderProps: () => ({ style: { position: "sticky", left: 280, background: "white", zIndex: 107,
                                        align: "right" } })

      }
    },
    { name: "material", label: "材質", },
    { name: "heat_treatment", label: "熱処理", },
    { name: "management_dept", label: "管理部署", },
    { name: "cost_div", label: "原価区分", },
    { name: "storage_bins", label: "棚番", },
    { name: "packing", label: "荷姿", },
    { name: "special_order_mark", label: "特注マーク", },
    { name: "order_stop_date", label: "発注停止日",  
      options: {
        customBodyRender:(cellValue: string) => {return dateEditDisplay(cellValue)}
      }
    },
    { name: "current", label: "現在庫", 
      options: {
        setCellHeaderProps: () => ({ style: {textAlign:"right" } }),
        setCellProps: (cellValue: any) => (columnStyleRightRed(cellValue)),
        customBodyRender:(cellValue: any) => {return commaEditDisplay(cellValue)}
      }
    },
    { name: "last_month", label: "前残", 
      options: {
        setCellHeaderProps: () => ({ style: {textAlign:"right" } }),
        setCellProps: (cellValue: any) => (columnStyleRightRed(cellValue)),
        customBodyRender:(cellValue: any) => {return commaEditDisplay(cellValue)}
      }
    },
    { name: "incoming", label: "入庫", 
      options: {
        setCellHeaderProps: () => ({ style: {textAlign:"right" } }),
        setCellProps: (cellValue: any) => (columnStyleRightRed(cellValue)),
        customBodyRender:(cellValue: any) => {return commaEditDisplay(cellValue)}
      }
    },
    { name: "outgoing", label: "出庫", 
      options: {
        setCellHeaderProps: () => ({ style: {textAlign:"right" } }),
        setCellProps: (cellValue: any) => (columnStyleRightRed(cellValue)),
        customBodyRender:(cellValue: any) => {return commaEditDisplay(cellValue)}
      }
    },
    { name: "relocation", label: "移転", 
      options: {
        setCellHeaderProps: () => ({ style: {textAlign:"right" } }),
        setCellProps: (cellValue: any) => (columnStyleRightRed(cellValue)),
        customBodyRender:(cellValue: any) => {return commaEditDisplay(cellValue)}
      }
    },
    { name: "returns", label: "返品", 
      options: {
        setCellHeaderProps: () => ({ style: {textAlign:"right" } }),
        setCellProps: (cellValue: any) => (columnStyleRightRed(cellValue)),
        customBodyRender:(cellValue: any) => {return commaEditDisplay(cellValue)}
      }
    },
    { name: "correction", label: "訂正", 
      options: {
        setCellHeaderProps: () => ({ style: {textAlign:"right" } }),
        setCellProps: (cellValue: any) => (columnStyleRightRed(cellValue)),
        customBodyRender:(cellValue: any) => {return commaEditDisplay(cellValue)}
      }
    },
    { name: "in_transit", label: "移動中", 
      options: {
        setCellHeaderProps: () => ({ style: {textAlign:"right" } }),
        setCellProps: (cellValue: any) => (columnStyleRightRed(cellValue)),
        customBodyRender:(cellValue: any) => {return commaEditDisplay(cellValue)}
      }
    },
    { name: "create_date", label: "作成日",  
      options: {
        customBodyRender:(cellValue: string) => {return dateEditDisplay(cellValue)}
      }
    },
    { name: "create_user", label: "作成者", },
    { name: "update_date", label: "更新日", 
      options: {
        customBodyRender:(cellValue: string) => {return dateEditDisplay(cellValue)}
      }
    },
    { name: "update_user", label: "更新者", },
  ];

  return (
    <GenericTemplate title="">
      <Stack spacing={1} direction="column" >
        <Stack spacing={2} direction="row">
          {/* 工場コード */}
          <FromTextFieldKojoCd onChange={chkKojoCd}
            label="保管場所"
            helperText={kojoCdError}
          />
          {/* 形番 */}
          <FromTextFieldKataban onChange={chkKataban}
            helperText={katabanError}
          />
          {/* 色コード */}
          <FromTextFieldColor onChange={chkColor}
            helperText={colorError}
          />
          {/* 定尺 */}
          <FromTextFieldTeisyaku onChange={chkTeisyaku}
            helperText={teisyakuError}
          />
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Box sx={{ m: 1, position: 'relative' }}>
              <Button variant="contained"
                sx={buttonSx}
                disabled={loading}
                onClick={() => { handleClick(); }}>
                検索
              </Button>
              {loading && (
                <CircularProgress
                  size={24}
                  sx={{
                    color: green[500],
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    marginTop: '-12px',
                    marginLeft: '-12px',
                  }}
                />
              )}
            </Box>
          </Box>
        </Stack>
        <div style={{ height: '50%', width: '100%' }}>
          <MUIDataTable
            title="在庫(stls)"
            data={post}
            columns={column}
            options={{
              selectableRows: 'none',
              rowsPerPage: 20,
              viewColumns: false,
              rowsPerPageOptions: [20, 50, 100],
              sort: false,
              print: false,
              setTableProps: () => {
                return {
                  // padding: 'none',
                  size: "small",
                  style: { whiteSpace: "nowrap" },
                };
              },
            }}
          />
        </div>
      </Stack>
    </GenericTemplate>
  )
}

export default P01Prg002Kata001